import classnames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import find from 'lodash/find';
import SimpleHeader from '../../../main/headers/simpleHeader';
import Money from '../../../common/money';
import { SHOP_CURRENCY } from '../../../main/shops/constants';

const priceForCurrency = (plan, currency) => {
  const price = find(plan.prices, { currency });
  if (price) {
    return (<Money currency={currency}>{price.price}</Money>);
  }

  return null;
};

const SubscriptionPlans = ({ plans, isReadOnlyAdmin }) => (
  <div className="u-p">
    <SimpleHeader heading="Subscription plans" />
    <Link
      className={classnames('c-btn c-btn--medium u-width-120', {
        'is-disabled no-pointer-events': isReadOnlyAdmin,
      })}
      to="/admin/subscription/plans/new"
    >
      New
    </Link>
    <div className="c-table-card c-table-new u-table-layout-fixed c-no-hover" display-if={plans.length}>
      <div className="c-table-card__head">
        <div className="c-table-card__cell c-label">Name</div>
        <div className="c-table-card__cell c-label">Active subscriptions</div>
        <div className="c-table-card__cell c-label">USD price</div>
        <div className="c-table-card__cell c-label">CAD price</div>
        <div className="c-table-card__cell c-label">GBP price</div>
        <div className="c-table-card__cell c-label">AUD price</div>
        <div className="c-table-card__cell c-label">EUR price</div>
        <div className="c-table-card__cell c-label">Actions</div>
      </div>
      {plans.map(plan => (
        <div className="c-table-card__row" key={plan.id}>
          <div className="c-table-card__cell">{plan.name}</div>
          <div className="c-table-card__cell">{plan.activeSubscriptionsCount}</div>
          <div className="c-table-card__cell">{priceForCurrency(plan, SHOP_CURRENCY.usd)}</div>
          <div className="c-table-card__cell">{priceForCurrency(plan, SHOP_CURRENCY.cad)}</div>
          <div className="c-table-card__cell">{priceForCurrency(plan, SHOP_CURRENCY.gbp)}</div>
          <div className="c-table-card__cell">{priceForCurrency(plan, SHOP_CURRENCY.aud)}</div>
          <div className="c-table-card__cell">{priceForCurrency(plan, SHOP_CURRENCY.eur)}</div>
          <div className="c-table-card__cell">
            <Link className="u-co-primary u-type--bold" to={`/admin/subscription/plans/${plan.id}`}>Edit</Link>
          </div>
        </div>
      ))}
    </div>
  </div>
);
SubscriptionPlans.propTypes = {
  plans: PropTypes.arrayOf(PropTypes.object).isRequired,
  isReadOnlyAdmin: PropTypes.bool.isRequired,
};

export default SubscriptionPlans;
